import React from 'react';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import HubTheme from '../../theme';

// Create spawnable dialogs.
// See https://www.npmjs.com/package/react-confirm for more

const AlertDialog = ({ show, proceed, dismiss, cancel, message, okText = "OK", title = "Something went wrong"}) => {
  const actions = [
    <FlatButton
      label={okText}
      primary={true}
      keyboardFocused={true}
      onTouchTap={() => proceed(true)}
    />,
  ];

  return (
    <HubTheme>
      <Dialog
        actions={actions}
        onRequestClose={dismiss}
        open={show}
        title={title}
        modal={false}
      >
        {message}
      </Dialog>
    </HubTheme>
  );
}

AlertDialog.propTypes = {
  show: PropTypes.bool,            // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func,         // from confirmable. call to close the dialog with promise resolved.
  cancel: PropTypes.func,          // from confirmable. call to close the dialog with promise rejected.
  dismiss: PropTypes.func,         // from confirmable. call to only close the dialog.
  message: PropTypes.string,       // arguments of your confirm function
  okText: PropTypes.string,        // Override cancel button text, defaults to: 'OK'
  title: PropTypes.string,         // Override title bar text, defaults to: 'Something went wrong'
}

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(AlertDialog);



// WEBPACK FOOTER //
// ./src/components/AlertDialog/index.jsx